import {
  editBenefit,
  editBenefitV2,
} from "../../infrastructure/repository/benefit-models-repository";
import { displayBenefitPage } from "./displays/display-benefit-page";
import { showErrorMessage } from "../commons/show-error-message";
import { translate } from "../../infrastructure/translate/localization";
import { logError } from "../../infrastructure/log";
// import { showSuccessMessage } from '../commons/show-success-message';

export async function editBenefitModel(benefit) {
  try {
    const { data } = await editBenefit(benefit);
    displayBenefitPage(data.id);
    // showSuccessMessage(`${res.name} actualizado.`)
  } catch (e) {
    logError(e, `Error to editBenefitModel ${benefit}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}

export async function editBenefitModelV2({ benefitId, state, benefitType }) {
  try {
    const { data } = await editBenefitV2({
      benefitId,
      state,
      benefitType,
    });
    displayBenefitPage(data.id);
  } catch (e) {
    logError(e, `Error editing editBenefitModel v2 ${benefitType}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
